module.exports = __webpack_public_path__ + "static/media/files.1cca4e91.svg";